module.exports = __webpack_public_path__ + "img/29.3f0b9ca9.png";